/*
 * Lashthing "Kies je look" configurator.
 * Vanilla custom element. Contract: docs/CONTRACT.md (repo lash-configurator).
 * Server rendert de complete markup; dit script muteert alleen state, tekst en afbeeldingen.
 */
(function () {
  'use strict';
  if (customElements.get('lash-configurator')) return;

  var ADDED_MS = 1800;
  var LIVE_DEBOUNCE_MS = 400;
  var URL_DEBOUNCE_MS = 300;
  var CART_OPEN_DELAY_MS = 700;

  function fill(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }

  function stripQuery(url) {
    return String(url || '').split('?')[0];
  }

  class LashConfigurator extends HTMLElement {}

  var proto = LashConfigurator.prototype;

  proto.connectedCallback = function () {
    var cfgEl = this.querySelector('[data-lash-config]');
    if (!cfgEl) return;
    try {
      this.cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return;
    }
    this.styles = this.cfg.styles || [];
    this.styleMap = {};
    for (var i = 0; i < this.styles.length; i++) this.styleMap[this.styles[i].key] = this.styles[i];
    if (!this.styles.length) return;

    this.reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.imgCache = {};
    this.ac = new AbortController();
    this.state = { style: null, length: null, prevStyle: null, compare: false };
    this.liveTimer = null;
    this.urlTimer = null;
    this.addedTimer = null;

    var initial = this.initialSelection();
    this.state.style = initial.style;
    this.state.length = initial.length;
    this.state.prevStyle = this.neighbourStyle(initial.style);

    this.bind();
    this.render(true);
    if (initial.fallbackFrom) {
      this.announce(fill(this.cfg.strings.liveFallback, {
        style: initial.fallbackFrom.title, mm: initial.fallbackFrom.mm,
        style2: this.currentStyle().title, mm2: this.state.length
      }));
    }
    this.setupSticky();
    this.setupWarmup();
    this.beacon('cfg_view', { mode: this.cfg.mode });
  };

  proto.disconnectedCallback = function () {
    if (this.ac) this.ac.abort();
    if (this.ioAtc) this.ioAtc.disconnect();
    if (this.ioSection) this.ioSection.disconnect();
    if (this.moCart) this.moCart.disconnect();
    clearTimeout(this.liveTimer);
    clearTimeout(this.urlTimer);
    clearTimeout(this.addedTimer);
  };

  /* ---------- selectie ---------- */

  proto.lengthOf = function (style, mm) {
    if (!style) return null;
    for (var i = 0; i < style.lengths.length; i++) {
      if (String(style.lengths[i].mm) === String(mm)) return style.lengths[i];
    }
    return null;
  };

  proto.currentStyle = function () {
    return this.styleMap[this.state.style];
  };

  proto.current = function () {
    return this.lengthOf(this.currentStyle(), this.state.length) || {};
  };

  proto.neighbourStyle = function (key) {
    var idx = -1;
    for (var i = 0; i < this.styles.length; i++) if (this.styles[i].key === key) idx = i;
    if (idx < 0) return this.styles[0].key;
    var next = this.styles[idx + 1] || this.styles[idx - 1] || this.styles[idx];
    return next.key;
  };

  proto.initialSelection = function () {
    var cfg = this.cfg;
    var sel = cfg.selected || {};
    var params = new URLSearchParams(window.location.search);
    var urlVariant = params.get('variant');
    // 1. deeplink ?variant= (blijft staan, ook als uitverkocht)
    if (urlVariant) {
      for (var i = 0; i < this.styles.length; i++) {
        for (var j = 0; j < this.styles[i].lengths.length; j++) {
          if (String(this.styles[i].lengths[j].variantId) === String(urlVariant)) {
            return { style: this.styles[i].key, length: String(this.styles[i].lengths[j].mm) };
          }
        }
      }
    }
    // 2. server-side geselecteerd (defaults) — met deterministische fallback bij onbeschikbaarheid
    var styleKey = this.styleMap[sel.style] ? sel.style : this.styles[0].key;
    var mm = sel.length || cfg.defaults.length || cfg.lengthOrder[0];
    var wanted = this.lengthOf(this.styleMap[styleKey], mm);
    if (wanted && wanted.available) return { style: styleKey, length: String(mm) };
    var fallback = this.findFallback(styleKey, mm);
    if (fallback) {
      return {
        style: fallback.style, length: fallback.length,
        fallbackFrom: { title: this.styleMap[styleKey].title, mm: mm }
      };
    }
    return { style: styleKey, length: String(mm) };
  };

  proto.lengthPreference = function (mm) {
    var order = (this.cfg.lengthOrder || []).map(String);
    var pref = [];
    if (order.indexOf(String(mm)) >= 0) pref.push(String(mm));
    var rest = order.filter(function (x) { return pref.indexOf(x) < 0; });
    rest.sort(function (a, b) { return Number(a) - Number(b); });
    return pref.concat(rest);
  };

  proto.findFallback = function (styleKey, mm) {
    var startIdx = 0;
    for (var i = 0; i < this.styles.length; i++) if (this.styles[i].key === styleKey) startIdx = i;
    var pref = this.lengthPreference(mm);
    for (var step = 0; step < this.styles.length; step++) {
      var style = this.styles[(startIdx + step) % this.styles.length];
      for (var p = 0; p < pref.length; p++) {
        var len = this.lengthOf(style, pref[p]);
        if (len && len.available) return { style: style.key, length: pref[p] };
      }
    }
    return null;
  };

  /* ---------- events ---------- */

  proto.bind = function () {
    var self = this;
    var opts = { signal: this.ac.signal };

    this.addEventListener('change', function (e) {
      var t = e.target;
      if (!(t instanceof HTMLInputElement)) return;
      if (t.hasAttribute('data-style')) self.set({ style: t.value }, 'style');
      else if (t.hasAttribute('data-length')) self.set({ length: t.value }, 'length');
    }, opts);

    this.addEventListener('click', function (e) {
      var atc = e.target.closest('[data-atc]');
      if (atc && self.contains(atc)) { e.preventDefault(); self.addToCart(atc); return; }
      var cmp = e.target.closest('[data-compare-toggle]');
      if (cmp && self.contains(cmp)) { e.preventDefault(); self.toggleCompare(); }
    }, opts);

    this.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.state.compare) {
        var cmp = self.querySelector('[data-compare-toggle]');
        if (cmp && document.activeElement === cmp) self.toggleCompare();
      }
    }, opts);

    document.addEventListener('shopify:block:select', function (e) {
      if (!e.detail || !self.contains(e.target)) return;
      var blockId = e.detail.blockId;
      for (var i = 0; i < self.styles.length; i++) {
        if (self.styles[i].blockId && self.styles[i].blockId === blockId) self.set({ style: self.styles[i].key }, 'editor');
      }
    }, opts);
  };

  proto.set = function (patch, source) {
    if (patch.style && patch.style !== this.state.style) {
      this.state.prevStyle = this.state.style;
      this.state.style = patch.style;
    }
    if (patch.length) this.state.length = String(patch.length);
    this.render(false);
    this.syncUrl();
    var v = this.current();
    var style = this.currentStyle();
    this.announce(fill(this.cfg.strings.live, { style: style.title, mm: this.state.length }));
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({
        event: 'lash_configurator_select',
        lc_style: style.key, lc_length: this.state.length, lc_variant_id: v.variantId || null, lc_source: source
      });
    }
    this.beacon('cfg_' + source, { style: style.key, length: this.state.length });
  };

  /* ---------- render ---------- */

  proto.text = function (sel, value) {
    var el = this.querySelector(sel);
    if (el) el.textContent = value == null ? '' : String(value);
  };

  proto.render = function (first) {
    var style = this.currentStyle();
    var v = this.current();
    var s = this.cfg.strings;
    var available = !!v.available;

    this.dataset.style = style.key;
    this.dataset.length = this.state.length;
    this.dataset.variantId = v.variantId ? String(v.variantId) : '';
    this.dataset.available = available ? 'true' : 'false';

    var styleRadio = this.querySelector('input[data-style][value="' + style.key + '"]');
    if (styleRadio && !styleRadio.checked) styleRadio.checked = true;
    var lengthRadio = this.querySelector('input[data-length][value="' + this.state.length + '"]');
    if (lengthRadio && !lengthRadio.checked) lengthRadio.checked = true;

    this.renderPills(style);

    var summary = style.title + ' · ' + this.state.length + ' mm';
    this.text('[data-summary]', summary);
    this.text('[data-sticky-summary]', summary);
    this.text('[data-price]', v.priceFormatted || '');
    this.text('[data-sticky-price]', v.priceFormatted || '');
    this.text('[data-caption]', this.captionFor(style, v));

    var details = this.querySelector('[data-details]');
    if (details) {
      var base = '/products/' + style.handle;
      details.setAttribute('href', v.originalVariantId ? base + '?variant=' + v.originalVariantId : base);
    }

    var stickyThumb = this.querySelector('[data-sticky-thumb]');
    if (stickyThumb && style.thumb && stickyThumb.getAttribute('src') !== style.thumb.src) stickyThumb.src = style.thumb.src;

    this.setAtcAvailability(available, style);
    if (!first) this.swapImage(this.imageFor(style, v));
    else this.preload(this.imageFor(style, v));
    if (this.state.compare) this.renderCompare();
    if (this.cfg.mode !== 'prelaunch' && this.dataset.state !== 'busy') this.setState(available ? 'idle' : 'soldout');
  };

  proto.renderPills = function (style) {
    var s = this.cfg.strings;
    var inputs = this.querySelectorAll('input[data-length]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var len = this.lengthOf(style, input.value);
      var ok = !!(len && len.available);
      if (ok) {
        input.removeAttribute('data-unavailable');
      } else {
        input.setAttribute('data-unavailable', 'true');
      }
      var label = this.querySelector('label[data-length-label="' + input.value + '"]');
      if (label) {
        label.classList.toggle('is-unavailable', !ok);
        var st = label.querySelector('[data-pill-state]');
        if (st) st.textContent = ok ? '' : s.soldOut;
      }
    }
  };

  proto.captionFor = function (style, v) {
    var s = this.cfg.strings;
    if (v && v.hasOwnImage) return fill(s.captionExact, { style: style.title, mm: this.state.length });
    var a = style.closeupLengths && style.closeupLengths[0];
    var b = style.closeupLengths && style.closeupLengths[1];
    if (a != null && b != null) return fill(s.captionMix, { style: style.title, a: a, b: b });
    return style.title;
  };

  proto.setAtcAvailability = function (available, style) {
    var s = this.cfg.strings;
    var buttons = this.querySelectorAll('[data-atc]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      btn.disabled = !available;
      var label = btn.querySelector('[data-atc-label]');
      var isSticky = btn.hasAttribute('data-atc-sticky');
      var txt = available ? (isSticky ? s.addToCartShort : s.addToCart) : s.soldOut;
      if (label) label.textContent = txt; else btn.textContent = txt;
    }
    var help = this.querySelector('[data-soldout]');
    if (help) {
      if (available) {
        help.hidden = true; help.textContent = '';
      } else {
        help.hidden = false;
        help.textContent = fill(s.soldOutHelp, { style: style.title, mm: this.state.length });
      }
    }
  };

  proto.setState = function (state) {
    this.dataset.state = state;
    this.classList.toggle('is-busy', state === 'busy');
  };

  /* ---------- afbeeldingen ---------- */

  proto.imageFor = function (style, v) {
    if (v && v.hasOwnImage && v.image) return v.image;
    return style.preview;
  };

  proto.preload = function (img) {
    if (!img || !img.src) return Promise.resolve();
    if (this.imgCache[img.src]) return this.imgCache[img.src];
    var el = new Image();
    if (img.sizes) el.sizes = img.sizes;
    if (img.srcset) el.srcset = img.srcset;
    el.src = img.src;
    var p = (el.decode ? el.decode() : new Promise(function (r) { el.onload = r; el.onerror = r; })).catch(function () {});
    this.imgCache[img.src] = p;
    return p;
  };

  proto.swapImage = function (img) {
    var self = this;
    var imgs = this.querySelectorAll('.lc__img');
    if (imgs.length < 2 || !img) return;
    var active = imgs[0].classList.contains('is-active') ? imgs[0] : imgs[1];
    var next = active === imgs[0] ? imgs[1] : imgs[0];
    if (stripQuery(active.getAttribute('src')) === stripQuery(img.src)) return;
    var token = (this.swapToken = (this.swapToken || 0) + 1);
    var timeout = new Promise(function (r) { setTimeout(r, 300); });
    Promise.race([this.preload(img), timeout]).then(function () {
      if (token !== self.swapToken) return;
      next.sizes = img.sizes || '';
      if (img.srcset) next.srcset = img.srcset; else next.removeAttribute('srcset');
      next.src = img.src;
      next.alt = img.alt || '';
      next.removeAttribute('aria-hidden');
      active.setAttribute('aria-hidden', 'true');
      var apply = function () {
        next.classList.add('is-active');
        active.classList.remove('is-active');
      };
      if (self.reduced) apply(); else requestAnimationFrame(apply);
    });
  };

  proto.setupWarmup = function () {
    var self = this;
    var c = navigator.connection;
    if (c && (c.saveData || /2g/.test(String(c.effectiveType || '')))) return;
    var run = function () {
      var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
      idle(function () {
        for (var i = 0; i < self.styles.length; i++) {
          if (self.styles[i].key !== self.state.style) self.preload(self.styles[i].preview);
        }
      });
    };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true, signal: this.ac.signal });
  };

  /* ---------- vergelijken ---------- */

  proto.toggleCompare = function () {
    var box = this.querySelector('[data-compare]');
    var btn = this.querySelector('[data-compare-toggle]');
    var stage = this.querySelector('[data-stage]');
    if (!box || !btn) return;
    this.state.compare = !this.state.compare;
    var s = this.cfg.strings;
    btn.setAttribute('aria-pressed', this.state.compare ? 'true' : 'false');
    btn.textContent = this.state.compare ? s.compareOff : s.compareOn;
    this.classList.toggle('is-comparing', this.state.compare);
    box.hidden = !this.state.compare;
    if (stage) stage.hidden = this.state.compare;
    if (this.state.compare) {
      this.renderCompare();
      var cur = this.currentStyle(), prev = this.styleMap[this.state.prevStyle] || cur;
      this.announce(fill(s.compareLive, { style: cur.title, style2: prev.title }));
      this.beacon('cfg_compare', { style: cur.key, previous: prev.key });
    } else {
      this.announce(s.compareLiveOff);
    }
  };

  proto.renderCompare = function () {
    var s = this.cfg.strings;
    var cur = this.currentStyle();
    var prevKey = this.state.prevStyle && this.state.prevStyle !== cur.key ? this.state.prevStyle : this.neighbourStyle(cur.key);
    var prev = this.styleMap[prevKey] || cur;
    var pairs = [['current', cur], ['previous', prev]];
    for (var i = 0; i < pairs.length; i++) {
      var img = this.querySelector('[data-compare-img="' + pairs[i][0] + '"]');
      var chip = this.querySelector('[data-chip="' + pairs[i][0] + '"]');
      var style = pairs[i][1];
      if (img && stripQuery(img.getAttribute('src')) !== stripQuery(style.preview.src)) {
        img.srcset = style.preview.srcset || '';
        img.sizes = '(min-width: 990px) 32rem, 50vw';
        img.src = style.preview.src;
        img.alt = style.preview.alt || style.title;
      }
      if (chip) chip.textContent = (pairs[i][0] === 'current' ? s.chosen : s.previous) + ' · ' + style.title;
    }
  };

  /* ---------- winkelwagen ---------- */

  proto.addToCart = function (btn) {
    var self = this;
    var v = this.current();
    var style = this.currentStyle();
    var s = this.cfg.strings;
    if (!v.variantId || !v.available || btn.disabled || this.dataset.state === 'busy') return;
    var root = this.cfg.cartRoot || '/';
    this.setBusy(btn, true);
    this.hideError();

    var precheck = window.fetch(root + 'products/' + v.originalHandle + '.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return true; // bron niet bereikbaar: Shopify (DENY) beslist bij add
        for (var i = 0; i < p.variants.length; i++) {
          if (String(p.variants[i].id) === String(v.originalVariantId)) return p.variants[i].available === true;
        }
        return true;
      })
      .catch(function () { return true; });

    precheck.then(function (ok) {
      if (!ok) { self.markSoldOut(style, v); return null; }
      return window.fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: v.variantId, quantity: 1 }] })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (r.status === 422 || (data && data.status === 422)) { self.markSoldOut(style, v); return null; }
          if (!r.ok) throw new Error(data && (data.description || data.message) || ('HTTP ' + r.status));
          return data;
        });
      }).then(function (data) {
        if (!data) return;
        self.setState('added');
        self.setAtcLabel(btn, s.added);
        self.announce(fill(s.liveAdded, { style: style.title, mm: self.state.length }));
        self.beacon('cfg_add', { style: style.key, length: self.state.length, variant: v.variantId });
        if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lash-configurator', productVariantId: v.variantId, cartData: data }); } catch (e) {}
        }
        self.openCart();
        clearTimeout(self.addedTimer);
        self.addedTimer = setTimeout(function () {
          if (self.dataset.state === 'added') { self.setState('idle'); self.setAtcAvailability(true, style); }
        }, ADDED_MS);
      });
    }).catch(function (err) {
      self.setState('error');
      self.showError(s.error + (err && err.message ? ' (' + err.message + ')' : ''));
      self.beacon('cfg_add_error', { msg: String(err && err.message || '').slice(0, 80) });
    }).then(function () {
      self.setBusy(btn, false);
    });
  };

  proto.markSoldOut = function (style, v) {
    v.available = false;
    this.setState('soldout');
    this.render(false);
    this.announce(fill(this.cfg.strings.liveSoldOut, { style: style.title, mm: this.state.length }));
  };

  proto.setAtcLabel = function (btn, txt) {
    var label = btn.querySelector('[data-atc-label]');
    if (label) label.textContent = txt; else btn.textContent = txt;
  };

  proto.setBusy = function (btn, busy) {
    if (busy) {
      this.setState('busy');
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('loading');
      var sp = btn.querySelector('.loading__spinner');
      if (sp) sp.classList.remove('hidden');
      this.setAtcLabel(btn, this.cfg.strings.adding);
    } else {
      btn.removeAttribute('aria-busy');
      btn.classList.remove('loading');
      var sp2 = btn.querySelector('.loading__spinner');
      if (sp2) sp2.classList.add('hidden');
      if (this.dataset.state === 'busy') this.setState('idle');
      if (this.dataset.state !== 'added') this.setAtcAvailability(!!this.current().available, this.currentStyle());
    }
  };

  proto.showError = function (msg) {
    var el = this.querySelector('[data-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (e) {}
  };

  proto.hideError = function () {
    var el = this.querySelector('[data-error]');
    if (el) { el.hidden = true; el.textContent = ''; }
  };

  proto.openCart = function () {
    var root = this.cfg.cartRoot || '/';
    setTimeout(function () {
      var kc = window.kachingCartApi;
      var drawer = document.querySelector('#kaching-cart');
      if (kc && typeof kc.openCart === 'function') {
        if (!drawer || !drawer.offsetHeight) {
          try { if (typeof kc.refreshCart === 'function') kc.refreshCart(); kc.openCart(); } catch (e) {}
        }
        return;
      }
      var dawn = document.querySelector('cart-drawer');
      if (!dawn || typeof dawn.renderContents !== 'function') return;
      window.fetch(root + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          if (sections && /id="CartDrawer"/.test(sections['cart-drawer'] || '')) dawn.renderContents({ sections: sections });
        }).catch(function () {});
    }, CART_OPEN_DELAY_MS);
  };

  /* ---------- sticky ---------- */

  proto.setupSticky = function () {
    var self = this;
    var bar = this.querySelector('[data-sticky]');
    var atc = this.querySelector('[data-atc]:not([data-atc-sticky])');
    if (!bar || !atc || !this.cfg.stickyCta || !('IntersectionObserver' in window)) return;
    this.stickyAtcVisible = true;
    this.stickyNearSection = true;
    var update = function () { self.updateSticky(bar); };
    this.ioAtc = new IntersectionObserver(function (entries) {
      var e = entries[0];
      self.stickyAtcAbove = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      self.stickyAtcVisible = e.isIntersecting;
      update();
    }, { threshold: 0 });
    this.ioAtc.observe(atc);
    this.ioSection = new IntersectionObserver(function (entries) {
      self.stickyNearSection = entries[0].isIntersecting;
      update();
    }, { rootMargin: '600px 0px 0px 0px', threshold: 0 });
    this.ioSection.observe(this);
    var kc = document.querySelector('#kaching-cart');
    if (kc && 'MutationObserver' in window) {
      this.moCart = new MutationObserver(update);
      this.moCart.observe(kc, { attributes: true, attributeFilter: ['class', 'style', 'open', 'aria-hidden'] });
    }
    window.addEventListener('resize', update, { passive: true, signal: this.ac.signal });
  };

  proto.foreignBottomBar = function () {
    var els = document.querySelectorAll('body *');
    var vh = window.innerHeight;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el === this || this.contains(el) || el.id === 'lashthing-chat-frame') continue;
      if (el.offsetHeight < 40) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') continue;
      var r = el.getBoundingClientRect();
      if (r.bottom >= vh - 2 && r.height >= 40 && r.width > vh * 0.5) return true;
    }
    return false;
  };

  proto.updateSticky = function (bar) {
    var kc = document.querySelector('#kaching-cart');
    var cartOpen = !!(kc && kc.offsetHeight && /open|active|visible/i.test(kc.className + ' ' + (kc.getAttribute('aria-hidden') === 'false' ? 'open' : '')));
    var show = window.innerWidth < 990 && this.stickyAtcAbove && this.stickyNearSection && !cartOpen && this.cfg.mode !== 'prelaunch' && !this.foreignBottomBar();
    if (show) {
      bar.hidden = false;
      bar.removeAttribute('inert');
      requestAnimationFrame(function () { bar.classList.add('is-visible'); });
    } else {
      bar.classList.remove('is-visible');
      bar.hidden = true;
      bar.setAttribute('inert', '');
    }
  };

  /* ---------- url / live / beacon ---------- */

  proto.syncUrl = function () {
    var self = this;
    clearTimeout(this.urlTimer);
    this.urlTimer = setTimeout(function () {
      var v = self.current();
      if (!v.variantId || !window.history || !window.history.replaceState) return;
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', String(v.variantId));
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (e) {}
    }, URL_DEBOUNCE_MS);
  };

  proto.announce = function (msg) {
    var self = this;
    clearTimeout(this.liveTimer);
    this.liveTimer = setTimeout(function () {
      var el = self.querySelector('[data-live]');
      if (!el) return;
      el.textContent = '';
      el.textContent = msg;
    }, LIVE_DEBOUNCE_MS);
  };

  proto.beacon = function (ev, props) {
    if (!this.cfg.analyticsBeacon) return;
    try {
      var env = 'live';
      if (window.location.search.indexOf('preview_theme_id') !== -1 || (window.Shopify && window.Shopify.designMode)) env = 'preview';
      else if (!/(^|\.)lashthing\.(nl|de|fr)$/.test(window.location.hostname)) env = 'preview';
      var sid = 'anon';
      try {
        sid = window.localStorage.getItem('lt_quiz_sid') || sid;
      } catch (e) {}
      window.fetch('https://timer.lashthing.nl/quiz-api/e', {
        method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sid: sid, env: env, ev: ev, props: props || {} })
      }).catch(function () {});
    } catch (e) {}
  };

  customElements.define('lash-configurator', LashConfigurator);
})();
